import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import tools from '../tools/tools.js';

import mainMarkup from '../markup2/filmsAFConsider.js';
import mainMarkupOnlyNumber from '../markup2/filmsAFConsiderOnlyNumber.js';
import mainMarkupList from '../markup2/filmsAFConsiderList.js';

import videoHistoryMarkup from '../markup2/videoHistory.js';

import mainMarkupLocalInputFilms from '../markup2/localInputFilms.js';
import mainMarkupLocalInputFilmsList from '../markup2/localInputFilmsList.js';
// import mainMarkupLocalInputFilmsOnlyNumbers from '../markup2/localInputFilms.js';

import mainMarkupStackLastFilm from '../markup2/stackLastFilmOpened.js';

import mainRejMarkup from '../markup2/filmCardMainRej.js';
import commentMarkup from '../markup2/filmCardComments.js';
import chatMarkup from '../markup2/filmCardChats.js';

import lastOpenedMarkup from '../markup2/filmCardLastUserOpenActivity.js';

import remarksMarkup from '../markup2/filmCardRemarks.js';
import authorMarkup from '../markup2/filmCardRequestAuthor.js';
import reviewDecisionsMarkup from '../markup2/reviewDecisionsRemarks.js';
import anotherFilmsPanelMarkup from '../markup2/anotherFilmsPanel.js';

import toolsMarkup from '../markup/tools.js';

import localInputBlock from './filmLocalInput.js';



const loaderSpinnerId = 'loader-filmAFConsider';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);


const mainTabPane = document.querySelector('#filmAFConsider');
const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
const mainTabPaneBTDataDisplay = mainTabPane.querySelector('button[name=typeDataDisplay]');
const mainTabPaneBTDataSort = mainTabPane.querySelector('button[name=typeDataSort]');
const mainTabPaneBTLookMsgChat = mainTabPane.querySelector('button[name=lookMsg]');
const mainTabPaneBTLookNewLinks = mainTabPane.querySelector('button[name=lookNewLinks]');
const mainTabPaneBTAddGlobalChat = mainTabPane.querySelector('button[name=addEveryoneToGlobalChat]');
const mainTabPaneBTSmartSearch = mainTabPane.querySelector('button[name=iconDataSmartSearch]');



const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');
// const mainTabPaneCalendarButtons = mainTabPane.querySelector('div[name=calendarDays]');

const arrayGroups = mainTabPane.querySelector('.groupsOfConsider');
const arrayGroupCountAll= arrayGroups.querySelector('#countAll');
const arrayGroupCountConsiderLater = arrayGroups.querySelector('#countConsiderLater');
const arrayGroupCountHaveQuestions = arrayGroups.querySelector('#countHaveQuestions');
const arrayGroupCountWaitAnswers = arrayGroups.querySelector('#countWaitAnswers');
const arrayGroupCountRejected = arrayGroups.querySelector('#countReject');


const cardConsider = document.querySelector('#filmConsider_card');

const chatHtmlBody = cardConsider.querySelector('div[name=chatBody]');

// const cardConsiderArrayGroups = cardConsider.querySelector('.groupsOfConsider');
const cardConsiderArrayGroups = cardConsider.querySelector('div[name=localStatus]');

const cardConsiderArrayTypeCompetition = cardConsider.querySelector('div[name=competitionType]');

const cardConsiderCommentField = cardConsider.querySelector('input[name=comment]');
const cardConsiderCommentAddBT = cardConsider.querySelector('button[name=commentAdd]');
const cardConsiderallTabs = cardConsider.querySelectorAll('.localTab');
const cardConsiderallTabsArea = cardConsider.querySelector('.localTabs');
const cardConsiderBtAgree = cardConsider.querySelector('button[name=agreeRequest]');
const cardConsiderBtDisAgree = cardConsider.querySelector('button[name=disagreeRequest]');
const cardConsiderBtComeBackAgree = cardConsider.querySelector('button[name=comebackRequest]');

const cardConsideRequestChange = document.querySelector('#filmConsider_card_request_to_change');
const cardConsiderToChangeNomination = document.querySelector('#filmConsider_card_change_nomination');


const cardConsiderToChangeNominationSelect = cardConsiderToChangeNomination.querySelector('select');

const cardLocalInputNominationSelect = document.querySelector('#filmLocalInput_Card').querySelector('select[name=nominations]');



const mypopupImg = document.getElementById("mypopupImg");

const universalViewSearchFiled = mainTabPane.querySelector('input[name=search]');

const menuBt = document.querySelector('#MenuFilmApplicationForConsider');

let typeRootViewController = 0;
// 0 - фильмы фестиваля 
// 1 - входящие заявки
// 2 - ручной импорт заявки

let allPosts = null;
let allLoadedData;
let allNotifications;
let allNotificationsVideo;
let allNominaitons = false;
let allAgreemetnLists = [];

let allcntUserReviewer;
let allRejectedLoadedData;
let allRejectedByApplicantLoadedData;

let dataGroup1;
let dataGroup2;
let dataGroup3;
let currentGroup = 0;
let currentGroupFilm = 0;
let currentRequestID = 0;
let currentFilmID = 0;
let currentCrew = '';
let currentNotification = null;
let currentNumberApplication = 0;
let currentCompetitionTypeFilm = 0;

let smartSeachResult = [];



let searchedData;

universalViewSearchFiled.addEventListener('keyup', function () {

  if (universalViewSearchFiled.value.length == 0) {
    mainTabPaneBTLookMsgChat.disabled = false;
    mainTabPaneBTLookNewLinks.disabled = false;
  } else {
    mainTabPaneBTLookMsgChat.classList.remove('activeBtn');
    mainTabPaneBTLookMsgChat.disabled = true;

    mainTabPaneBTLookNewLinks.classList.remove('activeBtn');
    mainTabPaneBTLookNewLinks.disabled = true;
  }

  mainTabPaneBTLookMsgChat.classList.remove('activeBtn');
  mainTabPaneBTLookNewLinks.classList.remove('activeBtn');

  if(typeRootViewController < 2)
    reDisplayData();
  else
    reDisplayDataLocalInput();
});


mainTabPaneBTLookMsgChat.addEventListener('click', function () {
    universalViewSearchFiled.value = '';
      mainTabPaneBTLookNewLinks.classList.remove('activeBtn');


    if(mainTabPaneBTLookMsgChat.classList.contains('activeBtn'))
      mainTabPaneBTLookMsgChat.classList.remove('activeBtn');
    else
      mainTabPaneBTLookMsgChat.classList.add('activeBtn');

    reDisplayData();
  });

mainTabPaneBTLookNewLinks.addEventListener('click', function (evt) {
    evt.preventDefault();

  if (evt.shiftKey) {

    if (confirm('Вы точно уверены, что хотите скрыть все уведомления?'))
     xhr.request = {
      metod: 'DELETE',
      url: `festival/${auth.currentFestival}/newlinkAlert`,
      data: '',
      callbackSuccess: loadData
    };
  } else {

    universalViewSearchFiled.value = '';
    mainTabPaneBTLookMsgChat.classList.remove('activeBtn');

    if(mainTabPaneBTLookNewLinks.classList.contains('activeBtn'))
      mainTabPaneBTLookNewLinks.classList.remove('activeBtn');
    else
      mainTabPaneBTLookNewLinks.classList.add('activeBtn');

    reDisplayData();
  }
});

cardConsider.querySelector('button[name=setPinCard]').addEventListener('click', function () {

  // console.log(parseInt(cardConsider.querySelector('button[name=setPinCard]').value) );
  // console.log(parseInt(cardConsider.querySelector('button[name=setPinCard]').value) ? 0 : 1);
  // return;
  xhr.request = {
      metod: 'GET',
        url: `filmRequest/${currentRequestID}/setpin/${parseInt(cardConsider.querySelector('button[name=setPinCard]').value) ? 0 : 1}`,
        data: '',
        callbackSuccess: (ans) => {
          console.log(ans);
          if (ans.status === 200)
            ans.data.lastOpened ? mainMarkupStackLastFilm.drawDataInContainer(ans.data.lastOpened) : mainMarkupStackLastFilm.cleanContainer();;
          
          checkRequestInStackLastOpened();
        }
      };

});

cardConsider.querySelector('button[name=addOneCardToGlobalChat]').addEventListener('click', function () {
  addCardtoGlobalChart(currentRequestID);
});

function  addCardtoGlobalChart(reqId) {
   if(confirm("Вы уверены, что хотите добавить данную заявку в массовую рассылку?")){
    // alert('Все добавл');
     xhr.request = {
      metod: 'POST',
      url: `festival/${auth.currentFestival}/addOneToGlobalChat/${reqId}`,
        data: '',
        callbackSuccess: (ans) => {
          toolsMarkup.informationtModal = {
            'isMess' : true,
            'title': 'Успех!',
            'message': ans.message
          };
        }
      };
    }
  // body...
}
mainTabPaneBTAddGlobalChat.addEventListener('click', function () {
  if(confirm("Вы уверены, что хотите добавить всех пользователей в массовую рассылку?")){
    // alert('Все добавл');
     xhr.request = {
      metod: 'POST',
      url: `festival/${auth.currentFestival}/addEveryOneToGlobalChat`,
        data: '',
        callbackSuccess: (ans) => {
          toolsMarkup.informationtModal = {
            'isMess' : true,
            'title': 'Успех!',
            'message': ans.message
          };
        }
      };
  }

});

mainTabPaneBTSmartSearch.addEventListener('click', () => {

  if (universalViewSearchFiled.value.length == 0) {
    alert('Введите в поле поиска более 3 символов');
  }else {

    
    mainTabPane.querySelector('div[name="foldersRow"]').hidden = true;
    mainTabPaneBody.style.display = 'none';
    // alert('request smart search');

    setInterval(()=>{
      cancelSmartSearch();
    },5000);
  }
});



function filterOnlyWithNewLinks(dataToMarkup) {
   
  if (!mainTabPaneBTLookNewLinks.classList.contains('activeBtn'))
    return dataToMarkup;
  else {
    mainMarkup.drawMarkupInContainer(loaderSpinnerMarkup);
    let newData = [];
    let copyData = dataToMarkup.slice();

    copyData.forEach((cElement) => {
        let was = false;
        allNotificationsVideo.forEach((nElement) => {
          if (parseInt(cElement.considerID) === parseInt(nElement.considerID))
            was = true;
        });
        if (was)
          newData.push(cElement);
    });

    return newData;
  }
}

function filterOnlyWithNewMsg (dataToMarkup) {
   
  if (!mainTabPaneBTLookMsgChat.classList.contains('activeBtn'))
    return dataToMarkup;
  else {

    mainMarkup.drawMarkupInContainer(loaderSpinnerMarkup);
    let newData = [];
    let copyData = dataToMarkup.slice();

    if(parseInt(mainTabPaneBTDataSort.value, 10) === 4 || parseInt(mainTabPaneBTDataSort.value, 10) === 5) {
    //// перерасчет по большему массиву - так как это уже отсортировано по номинациям и не вызывать метод пузырька
      copyData.forEach((cElement) => {
        let was = false;
        allNotifications.forEach((nElement) => {
          if (nElement.considerIDNewComment && (nElement.considerIDNewComment === cElement.considerID) && !was ||
              nElement.considerIDNewMessage && (nElement.considerIDNewMessage === cElement.considerID) && !was) {
                newData.push(cElement);
                copyData = arrayRemove(copyData,cElement);
                was = true;

          };
        });
      });

    } else {
      console.log('comment  here');
    }
      copyData.forEach((cElement) => {
        allNotifications.forEach((nElement) => {
          if (nElement.considerIDNewComment && (nElement.considerIDNewComment === cElement.considerID) ||
              nElement.considerIDNewMessage && (nElement.considerIDNewMessage === cElement.considerID)) {
                newData.push(cElement);
                copyData = arrayRemove(copyData,cElement);

          };
        });
      });
    return newData;

  }
};

function arrayRemove(arr, value) { 
    
        return arr.filter(function(ele){ 
            return ele != value; 
        });
    }
    
mainTabPaneBTDataSort.addEventListener('click', function () {
  // 0 - сортировка по номеру 
  // 1 - сортировка по алфавиту
  // 2 - сортировка по папкам
  let typeDataSort = mainTabPaneBTDataSort.value;
  mainTabPaneBTDataSort.classList.remove(`iconDataSort${typeDataSort}`);

  ++typeDataSort;
  if (typeDataSort === 6)
    typeDataSort = 0;

  mainTabPaneBTDataSort.value = typeDataSort;
  mainTabPaneBTDataSort.classList.add(`iconDataSort${typeDataSort}`);
  
  loadData();
});


mainTabPaneBTDataDisplay.addEventListener('click', function () {
  // 0 - список
  // 1 - только номера заявок
  // 2 - иконки
  // alert();
  let typeDataDisplay = mainTabPaneBTDataDisplay.value;
  mainTabPaneBTDataDisplay.classList.remove(`iconDataDisplay${typeDataDisplay}`);

  ++typeDataDisplay;
  if (typeDataDisplay === 3)
    typeDataDisplay = 0;

  mainTabPaneBTDataDisplay.value = typeDataDisplay;
  mainTabPaneBTDataDisplay.classList.add(`iconDataDisplay${typeDataDisplay}`);
  
  if(typeRootViewController < 2)
    reDisplayData();
  else
    reDisplayDataLocalInput(); // работа с ручным импортом
});


function initFirstSetup() {
  if(!allPosts)
    xhr.request = {
      metod: 'GET',
      url: 'posts',
      data: '',
      callbackSuccess: onSuccessPotsLoad
    };
    else
      loadData();

}
const onSuccessPotsLoad = (servAnswer) => {
  if (servAnswer.status === 200){
    allPosts = servAnswer.data; 
    loadData()
  }
};
mainTabPaneBTReload.addEventListener('click', function () {
  // alert('dfsdf');
  loadData();
});

function loadData () {
  mainMarkup.drawMarkupInContainer(loaderSpinnerMarkup);
  let funcOnServer = '';
  if(currentGroup == -1)
   xhr.request = {
      metod: 'GET',
      url: `festival/${auth.currentFestival}/sortType/${mainTabPaneBTDataSort.value}/filmRejected`,
      data: '',
      callbackSuccess: onSuccessRejectedLoad
    };
  else if(typeRootViewController < 2) { // работа с окном "входящие заявки" и "Фильмы фестиваля"
    if(typeRootViewController == 0)
      funcOnServer = 'fimlsInFestival';
    else if(typeRootViewController == 1)
      funcOnServer = 'filmAFConsider';   

    xhr.request = {
      metod: 'GET',
      url: `festival/${auth.currentFestival}/sortType/${mainTabPaneBTDataSort.value}/${funcOnServer}`,
      data: '',
      callbackSuccess: onSuccessPointsLoad
    };
  } else if(typeRootViewController == 2) { // работа с "Локальный импорт заявки"
    xhr.request = {
      metod: 'GET',
      url: `localInputFilms`,
      data: '',
      callbackSuccess: onSuccessLoadLocalInputs
    };
  }
}
// mainTabPane.querySelector('#typeDataDisplay').addEventListener('changed', function () {
//   reDisplayData();  reDisplayDataLocalInput
// });

function reDisplayDataLocalInput() {
  let curMarkup = null;

  let dataToMarkup = allLoadedData;

  if (mainTabPaneBTDataDisplay.value == 1)
    curMarkup = mainMarkupLocalInputFilms;
  else if(mainTabPaneBTDataDisplay.value == 2)
    curMarkup = mainMarkupLocalInputFilms;
  else 
    curMarkup = mainMarkupLocalInputFilmsList;

  if(universalViewSearchFiled.value.length == 0){
    // dataToMarkup = filterOnlyWithNewMsg(dataToMarkup);
    curMarkup.drawDataInContainer(dataToMarkup);
  }
  else{
    searchedData = [];

    dataToMarkup.forEach((element) => {
        if(parseInt(universalViewSearchFiled.value) === parseInt(element.numRequest))// поиск по номеру заявки
          searchedData.push(element);
        else if(tools.kmpSearch(universalViewSearchFiled.value,element.name ) != -1) // поиск по названию фильма
          searchedData.push(element);
    });
    
    curMarkup.cleanContainer();

    if(searchedData.length == 0)
      curMarkup.drawMarkupInContainer(`<p style="color:black;">Поиск не дал результатов</p>`)
    else
      curMarkup.drawDataInContainer(searchedData, allNotifications, allcntUserReviewer, allNotificationsVideo);
 
  }

}


function reDisplayData () {

  let curMarkup = null;
  if (mainTabPaneBTDataDisplay.value == 1)
    curMarkup = mainMarkupOnlyNumber;
  else if(mainTabPaneBTDataDisplay.value == 2)
    curMarkup = mainMarkup;
  else 
    curMarkup = mainMarkupList;

  curMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  let dataToMarkup;

  if(currentGroup == -1)
    dataToMarkup = allRejectedLoadedData;
  else if(currentGroup == 0)
    dataToMarkup = allLoadedData;
  else if(currentGroup == 1)
    dataToMarkup = dataGroup1;
  else if(currentGroup == 2)
    dataToMarkup = dataGroup2;
  else if(currentGroup == 3)
    dataToMarkup = dataGroup3;



  if(universalViewSearchFiled.value.length == 0){
    dataToMarkup = filterOnlyWithNewMsg(dataToMarkup);
    dataToMarkup = filterOnlyWithNewLinks(dataToMarkup);

    curMarkup.drawDataInContainer(dataToMarkup, allNotifications, allcntUserReviewer, allNotificationsVideo);

    if(allRejectedByApplicantLoadedData && allRejectedByApplicantLoadedData.length > 0 && mainTabPaneBTDataDisplay.value == 0)
      curMarkup.addDataRejectedInContainer(allRejectedByApplicantLoadedData);

  }
  else{
    searchedData = [];

    dataToMarkup.forEach((element) => {
      if(parseInt(universalViewSearchFiled.value) === parseInt(element.numRequest)) // поиск по номеру заявки
          searchedData.push(element);
      else if(tools.kmpSearch(universalViewSearchFiled.value,element.name ) != -1)
        searchedData.push(element);
    });
    
    curMarkup.cleanContainer();

    if(searchedData.length == 0)
      curMarkup.drawMarkupInContainer(`<p style="color:black;">Поиск не дал результатов</p>`)
    else
      curMarkup.drawDataInContainer(searchedData, allNotifications, allcntUserReviewer, allNotificationsVideo);
 
  }
}



arrayGroups.addEventListener('click', function (evt) {
    if(evt.target.attributes.value){
      if (currentGroup >0 && evt.target.attributes.value.nodeValue > 0) {
        currentGroup = evt.target.attributes.value.nodeValue;
        reDisplayData();
      } else {
        currentGroup = evt.target.attributes.value.nodeValue;
        loadData();
      }
    }
    // if (currentGroup < 0) {
    //   document.querySelector('#filmsExport_card').querySelector('b[name="header"]').innerHTML = 'Отклоненных заявок';
    //   document.querySelector('#filmsExport_card').querySelector('b[name="header"]').value = 0;
    // } else {
    //   document.querySelector('#filmsExport_card').querySelector('b[name="header"]').innerHTML = 'Входящих заявок';
    //   document.querySelector('#filmsExport_card').querySelector('b[name="header"]').value = 1;
    // }
    
    arrayGroups.querySelectorAll('.considerGroup').forEach((element) => {
      if (currentGroup == element.attributes.value.nodeValue)
        element.classList.add('active'); 
      else
        element.classList.remove('active');
   });
});
cardConsiderArrayGroups.addEventListener('click', function (evt) {
    if(evt.target.attributes.value){
      if (currentGroupFilm != evt.target.attributes.value.nodeValue ) {
        let arrPremissions = JSON.parse(auth.permissionsOnFest);
        if (parseInt(arrPremissions['cardTabLocalNotes'], 10) == 2){ 
          currentGroupFilm = evt.target.attributes.value.nodeValue;
          cardConsiderArrayGroups.querySelectorAll('.considerGroup').forEach((element) => {
            if (currentGroupFilm == element.attributes.value.nodeValue)
              element.classList.add('active'); 
            else
              element.classList.remove('active');
           });
          xhr.request = {
            metod: 'PUT',
            // url: `festival/${auth.currentFestival}/filmAFConsider/${currentRequestID}`,
            url: `filmRequest/${currentRequestID}`,
            data: `group=${currentGroupFilm}`,
            callbackSuccess: onSuccessUpdatedGroup
          };
        } else
         alert('Редактирование группы запрещено!');
      }
    }
});


cardConsiderArrayTypeCompetition.addEventListener('click', function (evt) {
    if(evt.target.attributes.value){
      if (currentCompetitionTypeFilm != evt.target.attributes.value.nodeValue )
        if(confirm('Вы уверены, что хотите изменить тип работы?'))
        {
          currentCompetitionTypeFilm = evt.target.attributes.value.nodeValue;
          cardConsiderArrayTypeCompetition.querySelectorAll('.considerGroup').forEach((element) => {
            if (currentCompetitionTypeFilm == element.attributes.value.nodeValue)
              element.classList.add('active'); 
            else
              element.classList.remove('active');
           });
          xhr.request = {
            metod: 'PUT',
            // url: `festival/${auth.currentFestival}/filmAFConsider/${currentRequestID}`,
            url: `filmRequest/${currentRequestID}`,
            data: `competitionType=${currentCompetitionTypeFilm}`,
            callbackSuccess: onSuccessUpdatedGroup
          };
        }
    }
});




const onSuccessUpdatedGroup = (servarAnswer) => {
  // document.querySelector(`#${loaderSpinnerId}`).remove();
  if (servarAnswer.status === 200) {
    loadData();
  }
};
cardConsiderCommentField.addEventListener('keyup', function (evt) {
  if(cardConsiderCommentField.value.length > 1)
    cardConsiderCommentAddBT.disabled = false;
  else
    cardConsiderCommentAddBT.disabled = true;
});;

cardConsiderCommentAddBT.addEventListener('click', function (evt) {
  if(confirm('Вы уверены, что хотите добавить заметку?')) {
    cardConsiderCommentAddBT.classList.add('load');
    xhr.request = {
        metod: 'POST',
        url: `filmRequest/${currentRequestID}/note`,
        data: `text=${cardConsiderCommentField.value}`,
        callbackSuccess: onSuccessAddComment
      };
  }
});

const onSuccessAddComment = (servarAnswer) => {
  if (servarAnswer.status === 200) {
    cardConsiderCommentField.value = '';
    cardConsiderCommentAddBT.classList.add('remove');
    commentMarkup.drawDataInContainer(servarAnswer.data);
  }
};

const onSuccessRejectedLoad = (servarAnswer) => {
  document.querySelector(`#${loaderSpinnerId}`).remove();
  if (servarAnswer.status === 200) {
    allNotificationsVideo = servarAnswer.data.notificationsVideoLinks ? servarAnswer.data.notificationsVideoLinks : [];
    allNotifications = servarAnswer.data.notifications;
    allRejectedLoadedData = servarAnswer.data.applications;
    allRejectedByApplicantLoadedData = servarAnswer.data.applicationsRejected ? servarAnswer.data.applicationsRejected : [];

    allcntUserReviewer = servarAnswer.data.reviewer;
    arrayGroupCountRejected.innerHTML = allRejectedLoadedData.length ? servarAnswer.data.countRejected : 0;
    reDisplayData();
  };
};
const onSuccessLoadLocalInputs = (servarAnswer) => {
  if(document.querySelector(`#${loaderSpinnerId}`))
    document.querySelector(`#${loaderSpinnerId}`).remove();

  allLoadedData = [];
  if (servarAnswer.status === 200) {
    allLoadedData = servarAnswer.data;
    reDisplayDataLocalInput();
    // mainMarkupLocalInputFilms.drawDataInContainer(servarAnswer.data);
  } else
    mainMarkup.drawMarkupInContainer(`<p>Данный пока нет!</p>`);
};

const onSuccessPointsLoad = (servarAnswer) => {
  if(document.querySelector(`#${loaderSpinnerId}`))
    document.querySelector(`#${loaderSpinnerId}`).remove();
  
  if (servarAnswer.status === 200) {

      servarAnswer.data.lastOpened ? mainMarkupStackLastFilm.drawDataInContainer(servarAnswer.data.lastOpened) : mainMarkupStackLastFilm.cleanContainer();;

    if(servarAnswer.data.permissionsOnFest)
      auth.permissionsOnFest = JSON.stringify(servarAnswer.data.permissionsOnFest);


    if(servarAnswer.data.agreementList)
      allAgreemetnLists = servarAnswer.data.agreementList;


    allNotificationsVideo = servarAnswer.data.notificationsVideoLinks ? servarAnswer.data.notificationsVideoLinks : [];
    allNotifications = servarAnswer.data.notifications;
    allLoadedData = servarAnswer.data.applications;
    arrayGroupCountAll.innerHTML = allLoadedData.length;
    allcntUserReviewer = servarAnswer.data.reviewer;
    arrayGroupCountRejected.innerHTML = servarAnswer.data.countRejected ? servarAnswer.data.countRejected : 0;
    dataGroup1 = [];
    dataGroup2 = [];
    dataGroup3 = [];
    allRejectedByApplicantLoadedData = [];
    if(allLoadedData) {
      allLoadedData.forEach((element) => {
        if(element.localgroup)
        {
          if(element.localgroup == 1)
            dataGroup1.push(element);
          else if(element.localgroup == 2)
            dataGroup2.push(element);
          else if(element.localgroup == 3)
            dataGroup3.push(element);
        }
      });

      arrayGroupCountConsiderLater.innerHTML = dataGroup1.length;
      arrayGroupCountHaveQuestions.innerHTML = dataGroup2.length;
      arrayGroupCountWaitAnswers.innerHTML = dataGroup3.length;
    } else {
      arrayGroupCountConsiderLater.innerHTML = '-';
      arrayGroupCountHaveQuestions.innerHTML = '-';
      arrayGroupCountWaitAnswers.innerHTML = '-';
      arrayGroupCountAll.innerHTML = '-';
      arrayGroupCountRejected.innerHTML = '-';
    }
    reDisplayData();
    // FestName.innerHTML = servarAnswer.message;
  } else
    mainMarkup.drawMarkupInContainer(`<p>Данный пока нет!</p>`
      );
};


mainTabPaneBody.addEventListener('click', function (evt) {
  evt.preventDefault();

  if (evt.shiftKey && evt.target.attributes.alertNewLinkForfCID) {
    if (confirm('Вы точно уверены, что хотите скрыть данное уведомление?'))
         xhr.request = {
          metod: 'DELETE',
          url: `filmRequest/${evt.target.attributes.alertNewLinkForfCID.nodeValue}/newlinkAlert`,
          data: '',
          callbackSuccess: loadData
        };
  } else if(evt.shiftKey && evt.target.attributes.review_value){


    let newReviewValue = evt.target.attributes.review_value.nodeValue;
    --newReviewValue;
    if(newReviewValue < 0)
      newReviewValue = 5;

    // alert(newReviewValue);
     xhr.request = {
        metod: 'PUT',
        url: `filmRequest/${evt.target.attributes.fCID.nodeValue}/review`,
        data: `answer=${newReviewValue}`,
        callbackSuccess: loadData
      };
  
  } else if(evt.shiftKey && evt.target.attributes.lastMsg && evt.target.attributes.fCID ){

    let newMsg =  prompt("Отправить новое сообщение:");
    if(newMsg && newMsg.length > 0)
    {
        xhr.request = {
          metod: 'POST',
          url: `filmRequest/${evt.target.attributes.fCID.nodeValue}/msgInChat`,
          data: `text=${newMsg}`,
          callbackSuccess: loadData
        };
    }

  } else if(evt.metaKey && evt.target.attributes.lastMsg && evt.target.attributes.fCID )
   addCardtoGlobalChart(evt.target.attributes.fCID.nodeValue);

  else if(evt.target.attributes.fCID && !evt.shiftKey && typeRootViewController < 2){
    if(evt.target.attributes.numReq)
      currentNumberApplication = evt.target.attributes.numReq.nodeValue;
    else 
      currentNumberApplication = 0;

    loadRequestFilm(evt.target.attributes.fCID.nodeValue, false);
  } else if(evt.target.attributes.fCID && !evt.shiftKey && typeRootViewController == 2)
     localInputBlock.openCard(evt.target.attributes.fCID.nodeValue);
  
});

cardConsiderBtDisAgree.addEventListener('click', function (evt) {
  if (confirm('Вы уверены, что данная заявка будет отклонена?\n\nВы можете указать описание причины отказа автору заявки!')) {
    xhr.request = {
      metod: 'PUT',
      // url: `festival/${auth.currentFestival}/filmAFConsider/${currentRequestID}`,
      url: `filmRequest/${currentRequestID}`,
      data: `status=0&comment=${cardConsider.querySelector('textarea[name=decisionComment').value}`,
      callbackSuccess: onSuccessAgree
    };
  }
});
cardConsiderBtAgree.addEventListener('click', function (evt) {
  if (confirm('Вы уверены, что работа прошла отбор на ваш фестиваль?')) {
    xhr.request = {
      metod: 'PUT',
      // url: `festival/${auth.currentFestival}/filmAFConsider/${currentRequestID}`,
      url: `filmRequest/${currentRequestID}`,
      data: `status=2`,
      callbackSuccess: onSuccessAgree
    };
  }
});

cardConsiderBtComeBackAgree.addEventListener('click', function (evt) {
if (confirm('Вы уверены, что работу нужно вернуть обратно на рассмотрение?')) {
    xhr.request = {
      metod: 'PUT',
      // url: `festival/${auth.currentFestival}/filmAFConsider/${currentRequestID}`,
      url: `filmRequest/${currentRequestID}`,
      data: `status=1`,
      callbackSuccess: onSuccessAgree
    };
  }
});
const onSuccessAgree = (servarAnswer) => {
  if (servarAnswer.status === 200) {
    $(cardConsider).modal('hide');
    loadData();
  };
};
cardConsider.querySelector('i[name=correctNameRUS]').addEventListener('click', function (evt) {

  if(cardConsider.querySelector('i[name=correctNameRUS]').classList.contains('activeBtn')){
    cardConsideRequestChange.querySelector('input[name=nameFilm]').value = cardConsider.querySelector('b[name=film-name]').innerHTML;
    cardConsideRequestChange.querySelector('input[name=nameSerial]').value = cardConsider.querySelector('b[name=film-serial]').innerHTML;
    cardConsideRequestChange.attributes.requestBlock.nodeValue = 'correctNameRUS';
    prepareAndShowcardConsideRequestChange();
  }
});
cardConsider.querySelector('i[name=correctNameEng]').addEventListener('click', function (evt) {

  if(cardConsider.querySelector('i[name=correctNameEng]').classList.contains('activeBtn')){
    cardConsideRequestChange.querySelector('input[name=nameFilm]').value =  cardConsider.querySelector('b[name=film-nameEng]').innerHTML;
    cardConsideRequestChange.querySelector('input[name=nameSerial]').value = cardConsider.querySelector('b[name=film-serialEng]').innerHTML;
    cardConsideRequestChange.attributes.requestBlock.nodeValue = 'correctNameEng';
    prepareAndShowcardConsideRequestChange();
  }
});

function prepareAndShowcardConsideRequestChange (){
  cardConsideRequestChange.querySelector('button[name=send]').disabled = true;
  cardConsideRequestChange.querySelector('input[name=nameFilm]').attributes.oldvalue = cardConsideRequestChange.querySelector('input[name=nameFilm]').value;
  cardConsideRequestChange.querySelector('input[name=nameSerial]').attributes.oldvalue = cardConsideRequestChange.querySelector('input[name=nameSerial]').value;
  $(cardConsider).modal('hide');
  $(cardConsideRequestChange).modal('show');
}
cardConsideRequestChange.querySelector('input[name=nameFilm]').addEventListener('keyup', function (evt) {
  validCardConsideRequestChange();

});
cardConsideRequestChange.querySelector('input[name=nameSerial]').addEventListener('keyup', function (evt) {
  validCardConsideRequestChange();

});
function validCardConsideRequestChange () {
  if(cardConsideRequestChange.querySelector('input[name=nameFilm]').attributes.oldvalue === cardConsideRequestChange.querySelector('input[name=nameFilm]').value &&
    cardConsideRequestChange.querySelector('input[name=nameSerial]').attributes.oldvalue === cardConsideRequestChange.querySelector('input[name=nameSerial]').value)
    cardConsideRequestChange.querySelector('button[name=send]').disabled = true;
  else
    cardConsideRequestChange.querySelector('button[name=send]').disabled = false;
}
 cardConsideRequestChange.querySelector('button[name=send]').addEventListener('click', function () {
  let allInputs = cardConsideRequestChange.querySelectorAll('input');
  let strBody = '';
  allInputs.forEach((element) => {
    strBody = `${strBody}${element.attributes.name.nodeValue}=${element.value}&`;
  });

  xhr.request = {
    metod: 'POST',
    url: `filmRequest/${currentRequestID}/requstToEdit`,
    data: `${strBody}localKey=${cardConsideRequestChange.attributes.requestBlock.nodeValue}`,
    callbackSuccess: onSuccessSendRequest
  };

 });

 cardConsideRequestChange.querySelector('button[name=cancel]').addEventListener('click', function () {
    $(cardConsideRequestChange).modal('hide');

    setTimeout(function() { 
      $(cardConsider).modal('show');
    }, 1000);

 });
 const onSuccessSendRequest = (servarAnswer) => {
  // document.querySelector(`#${loaderSpinnerId}`).remove();
  if (servarAnswer.status === 270) {
    cardConsider.querySelector(`b[name=${cardConsideRequestChange.attributes.requestBlock.nodeValue}Wait]`).hidden = false;
 
    $(cardConsideRequestChange).modal('hide');
    setTimeout(function() { 
       $(cardConsider).modal('show');
    },700);

  }

};





function getSelectionText() {
    var text = "";
    if (window.getSelection) {
        text = window.getSelection().toString();
    } else if (document.selection && document.selection.type != "Control") {
        text = document.selection.createRange().text;
    }
    return text;
}

function showblocks(typeBlock, show){

  let allBlocks = cardConsider.querySelectorAll(`.blockTypeWork${typeBlock}`);
  allBlocks.forEach((element) => {
    if (!show)
      element.classList.add('d-none'); 
    else
     element.classList.remove('d-none');
  });

}
const onSuccessConsiderLoad = (servarAnswer) => {

  const date = new Date();
  const curTimeZone = (date.getTimezoneOffset())/60 * -1;

  // document.querySelector(`#${loaderSpinnerId}`).remove();
  if (servarAnswer.status === 200) {

      servarAnswer.data.lastOpened ? mainMarkupStackLastFilm.drawDataInContainer(servarAnswer.data.lastOpened) : mainMarkupStackLastFilm.cleanContainer();;

    let requestFilmInfo = servarAnswer.data.requestFilm;
    let typeWork = requestFilmInfo.typeWork;
  

    if (parseInt(typeWork, 10) == 1){

      showblocks(1,true);
      showblocks(2,false);
    }
    else{
      showblocks(1, false);
      showblocks(2, true);
    }

    currentFilmID = requestFilmInfo.id;
    cardConsider.querySelector('b[name=film-name]').innerHTML = (requestFilmInfo.name ? requestFilmInfo.name : 'ошибка!');
    cardConsider.querySelector('b[name=film-nameEng]').innerHTML = (requestFilmInfo.nameEng ? requestFilmInfo.nameEng : '');
    cardConsider.querySelector('p[name=film-description]').innerHTML = (requestFilmInfo.description ? requestFilmInfo.description : '');
    cardConsider.querySelector('p[name=film-descriptionEng]').innerHTML = (requestFilmInfo.descriptionEng ? requestFilmInfo.descriptionEng : '');

    cardConsider.querySelector('b[name=film-serial]').innerHTML = (requestFilmInfo.serial ? requestFilmInfo.serial : '');
    cardConsider.querySelector('b[name=film-serialEng]').innerHTML = (requestFilmInfo.serialEng ? requestFilmInfo.serialEng : '');

    // проверка - не отправлен ли запрос на модерацию данных
    cardConsider.querySelector('b[name=correctNameRUSWait]').hidden = true;
    cardConsider.querySelector('b[name=correctNameEngWait]').hidden = true;

// requestFilmInfo
    if(servarAnswer.data.requestToEditData)
      servarAnswer.data.requestToEditData.forEach((element) => {
        cardConsider.querySelector(`b[name=${element.localKey}Wait]`).hidden = false;

      });

    let htmlCLOUDs = '';
    htmlCLOUDs += makeClouds(requestFilmInfo.long,'long', 0 );
    htmlCLOUDs += makeClouds(requestFilmInfo.year,'year', 0);
    htmlCLOUDs += makeClouds(requestFilmInfo.age,'age', 0);
    htmlCLOUDs += makeClouds(requestFilmInfo.premiere,'premiere', 0);


    // htmlCLOUDs += makeClouds(requestFilmInfo.rentalCert,'rentalCert');

    cardConsider.querySelector('p[name=timeRequest]').innerHTML = tools.dateStringFullAddTimeZone(requestFilmInfo.requestTime, curTimeZone);
    cardConsider.querySelector('p[name=file-comm]').innerHTML = requestFilmInfo.comment;
    
    cardConsider.querySelector('a[name=file-url]').href = requestFilmInfo.trailLink;
    cardConsider.querySelector('a[name=file-url]').innerHTML = requestFilmInfo.trailLink;
    cardConsider.querySelector('p[name=file-pass]').innerHTML = requestFilmInfo.trailPass;

    if (servarAnswer.data.techs)
      servarAnswer.data.techs.forEach((element) => {
         htmlCLOUDs += makeClouds(element.name,'tech', element.id);
      });  

    if (servarAnswer.data.county)
      servarAnswer.data.county.forEach((element) => {
         htmlCLOUDs += makeClouds(element.name,'country', element.id);
      });
    cardConsider.querySelector('div[name=Clouds]').innerHTML = htmlCLOUDs;


// ПРОКАТНОЕ УДОСТОВЕРЕНИЕ!
    let procatStatus = (requestFilmInfo.rentalCertStatus) ? parseInt(requestFilmInfo.rentalCertStatus, 10): 0;
    let procatHTML = `<div class="row m-0 p-1 w-100" name="rentCert-status">`;
    if (procatStatus == 0) 
      procatHTML += ' Нет и не будет.'
    else if (procatStatus == 1)
      procatHTML += 'В процессе ...'
    if (procatStatus == 2) {
      if(requestFilmInfo.rentalCert)
      procatHTML += `<b class="mr-3" name="rentCert-numb">${requestFilmInfo.rentalCert}</b>`;

      if(requestFilmInfo.rentalCertDate)
        procatHTML += `<div name="rentCert-date">${tools.dateStringShort(requestFilmInfo.rentalCertDate)}</div>`;

      if(requestFilmInfo.rentalCertImg)
        procatHTML += `<a href="https://storage.yandexcloud.net/fest-content-0/rentCerts/${requestFilmInfo.rentalCertImg}.jpg" name="rentCert-img" class=" ml-auto mr-1" target="_blank">Скан прокатного удостоверения.</a>`;
    }
    procatHTML += `</div>`;

    cardConsider.querySelector('div[name=rentCert]').innerHTML = procatHTML;
// КАДры фильма
    let allFrames = '';
    let boxFrameOnReserv = '<br><div class="box-reserv-image row localgroup ml-auto mr-0 mb-0 mt-auto"> <div class="imgs">';
    if (servarAnswer.data.frames)
      servarAnswer.data.frames.forEach((element) => {
         allFrames += makeFrame(element.image,(servarAnswer.data.frames.length < 7) ? 300 : 150);
         // boxFrameOnReserv += '<img src="https://festcontent.ru/films/yandexcloudCopy/' + element.image +'.jpg" class="smallPreviewOnServ">';
      });

    boxFrameOnReserv += '</div><button class="btn btn-success" srcSource="servOwn">Просмотреть из резервной копии</button></div>';
    cardConsider.querySelector('div[name=frames]').innerHTML = allFrames + boxFrameOnReserv;
     // cardConsider.querySelector('div[name=frames]').insetAfter = 

//  КТО работал над фильмом!
    currentCrew = requestFilmInfo.creators;
    displayCrew();

// СТУДИИ
    let educationDivBlock = '<div class="row m-0 p-1"><b class="p-0 mr-3">';


    cardConsider.querySelector('label[name=studio-label]').innerHTML = '';

    if (parseInt(requestFilmInfo.studioType, 10) == 0) 
      cardConsider.querySelector('label[name=studio-label]').innerHTML = 'Без студии';
    else if(parseInt(requestFilmInfo.studioType, 10) == 1)
      cardConsider.querySelector('label[name=studio-label]').innerHTML = 'Cтудия - производитель:';
    else if(parseInt(requestFilmInfo.studioType, 10) == 2){
      cardConsider.querySelector('label[name=studio-label]').innerHTML = 'Учебное заведение:';

      if (parseInt(requestFilmInfo.eduType, 10) == 0)
        educationDivBlock += 'Учебная работа';
      else if (parseInt(requestFilmInfo.eduType, 10) == 1)
        educationDivBlock += 'Курсовая работа';
      else if (parseInt(requestFilmInfo.eduType, 10) == 2)
        educationDivBlock += 'Дипломная работа';
      else
        educationDivBlock += ' ';

      educationDivBlock += '</b> Курс: <span>';
      educationDivBlock += requestFilmInfo.eduYear ? requestFilmInfo.eduYear : '  уне казан!';

      educationDivBlock += '</span><b class="ml-3 p-0">';
      educationDivBlock += requestFilmInfo.eduTeacher ? requestFilmInfo.eduTeacher : '';
        
    }
    else
      cardConsider.querySelector('label[name=studio-label]').innerHTML = '-';;


    educationDivBlock += '</b></div>';
    cardConsider.querySelector('div[name=educationInfo]').innerHTML = educationDivBlock;

 

    if (requestFilmInfo.studioTeacher) {
      cardConsider.querySelector('label[name=studio-teacher-label]').innerHTML = 'Руководитель студии: ';
      cardConsider.querySelector('b[name=studio-teacher]').innerHTML = requestFilmInfo.studioTeacher;
    } else {
      cardConsider.querySelector('label[name=studio-teacher-label]').innerHTML = '';
      cardConsider.querySelector('b[name=studio-teacher]').innerHTML = '';
    }

//eduType

    let allStudios = '';
    if (servarAnswer.data.studios)
      servarAnswer.data.studios.forEach((element) => {
        let divDelegate = '';
        if(element.delegate)
          divDelegate = `<div class=" m-0 mr-3 p-0" name="studio-${element.id}-delegate">${element.delegate}</div>`;


        let divMail = '';
        if(element.mail)
          divMail = `<div class=" m-0 mr-3 p-0" name="studio-${element.id}-mail">${element.mail}</div>`;


        let divPhone = '';
        if(element.phone)
          divPhone = `<b class=" m-0 mr-3 p-0" name="studio-${element.id}-phone">${element.phone}</b>`;

        let divSite = '';
        if(element.site)
          divSite = `<a href="${element.site}" class=" m-0 mr-3 p-0" name="studio-${element.id}-site">${element.site}</a>`;


         allStudios += `<div class="w-100 p-10 column cloud">
                          <div class= "w-100 m-0 p-0 row"> 
                            <b  name="studio-${element.id}-name">${element.name}</b>
                            <div class="ml-auto mr-0 row p-0" >${divDelegate} ${divMail} ${divPhone} ${divSite}</div>
                          </div>
                          <div class="w-100 row p-3">${anotherFilmsPanelMarkup.drawDataInDiv(element.studioFilms, currentFilmID)}</div>
                        </div> `;
      });
    cardConsider.querySelector('div[name=studio]').innerHTML = allStudios;

// правообладатели
    let allOwners = '';
    if (servarAnswer.data.owners)
      servarAnswer.data.owners.forEach((element) => {
        let divAdress = '';
        if(element.adress)
          divAdress = `<div class=" m-0 p-1 w-100" name="owner-${element.id}-adress">${element.adress}</div>`;

        let divMail = '';
        if(element.mail)
          divMail = `<div class=" m-0 mr-3 p-0" name="owner-${element.id}-mail">${element.mail}</div>`;

        let divPhone = '';
        if(element.phone)
          divPhone = `<b class=" m-0 mr-3 p-0" name="owner-${element.id}-phone">${element.phone}</b>`;

         allOwners += `<div class="w-100 p-10 column">
                        <div class="w-100 p-0 m-0 row"> 
                            <b  name="owner-${element.id}-name">${element.name}</b>
                            <div class="ml-auto mr-0 row p-0" >${divMail} ${divPhone}</div>
                            ${divAdress}
                        </div>

                        <div class="w-100 row">${anotherFilmsPanelMarkup.drawDataInDiv(element.ownerFilms, currentFilmID)}</div>
                      </div>`;
      });
    cardConsider.querySelector('div[name=owner]').innerHTML = allOwners;



    mainRejMarkup.drawDataInContainer(servarAnswer.data.rej, currentFilmID);
  
    currentCompetitionTypeFilm = servarAnswer.data.competitionType;

    // if
    cardConsiderArrayTypeCompetition.querySelectorAll('.considerGroup').forEach((element) => {
      if (currentCompetitionTypeFilm == element.attributes.value.nodeValue)
        element.classList.add('active'); 
      else
       element.classList.remove('active');
    });


    currentGroupFilm = servarAnswer.data.group;
    cardConsiderArrayGroups.querySelectorAll('.considerGroup').forEach((element) => {
      if (currentGroupFilm == element.attributes.value.nodeValue)
        element.classList.add('active');
      else
        element.classList.remove('active');
     });

    cardConsiderCommentField.value = '';

    cardConsider.querySelector('b[name=fest-nomination]').innerHTML = servarAnswer.data.nomination.nameRU;

    if (servarAnswer.data.status && servarAnswer.data.status > 0) {// блокировки по статусу заявки!
     
      cardConsider.querySelector('h1[name=countAgreeReviewPoints]').style.display = 'none';
      cardConsider.querySelector('button[name=comebackRequest]').style.display = 'none';
      cardConsider.querySelector('button[name=agreeRequest]').style.display = 'none';

      cardConsiderBtDisAgree.disabled = false;

      if (servarAnswer.data.status == 1) {

        cardConsider.querySelector('h1[name=countAgreeReviewPoints]').style.display = 'grid';
        cardConsider.querySelector('button[name=agreeRequest]').style.display = 'flex';
        // alert('в рассмотрении заявка');
      } 
      // else if(servarAnswer.data.status == 2)
        // alert('Одобренная заявка');  
    }
    else{
      cardConsider.querySelector('h1[name=countAgreeReviewPoints]').style.display = 'none';
      cardConsider.querySelector('button[name=agreeRequest]').style.display = 'none';
      cardConsider.querySelector('button[name=comebackRequest]').style.display = 'flex';


      cardConsiderBtDisAgree.disabled = true;
    }
    // let mainRej = [];
    currentNotification = servarAnswer.data.notifications;
    initLocalTabs();
    localTabsNotificationsUpdate();

    if(servarAnswer.data.notificationsChat)
        cardConsiderallTabsArea.querySelector('button[name="chatWithRej"]').classList.add('little-icon-newMsg');
    else
        cardConsiderallTabsArea.querySelector('button[name="chatWithRej"]').classList.remove('little-icon-newMsg');
    

    //обнуление отметок
    Array.from(cardConsider.querySelectorAll("[name]")).forEach( function (el) {
      el.classList.remove('blockHaveQuestion');
      el.classList.remove('blockWaitReview');
      if (servarAnswer.data.remarks)
        servarAnswer.data.remarks.forEach((element) => {
          if (el.getAttribute("name") === element.block) {
            if (element.status === 1)
              el.classList.add('blockHaveQuestion');
            else if(element.status === 2)
              el.classList.add('blockWaitReview');
          }
         });
      
    });
    remarksMarkup.drawDataInContainer();

    //добавлении информации о заявителе
    authorMarkup.cleanContainer();
    authorMarkup.drawDataInContainer(servarAnswer.data.manager);
  // отображение причины отказа
  
  //  список предоставленных согласий

    let allAgreemetnClouds = '';
    

    if(requestFilmInfo.agreementList)
      JSON.parse(requestFilmInfo.agreementList).forEach((element) => {
        allAgreemetnLists.forEach((aElement) => {
          if(aElement.id == element)
               allAgreemetnClouds += `<div class="cloud">${aElement.name}</div>`;
        });
     
      });  
    
    cardConsider.querySelector('div[name=cloudsArrAgreemnts]').innerHTML = allAgreemetnClouds;

    if(servarAnswer.data.publicLastComment){
      cardConsider.querySelector('textarea[name=decisionComment').value = servarAnswer.data.publicLastComment;
      cardConsider.querySelector('textarea[name=decisionComment').disabled = true;
    } else {
      cardConsider.querySelector('textarea[name=decisionComment').value = '';
      cardConsider.querySelector('textarea[name=decisionComment').disabled = false;
    }

    cardConsider.querySelector('b[name=requestHideKey]').innerHTML = requestFilmInfo.requestHideKey ? requestFilmInfo.requestHideKey : '';


    if (servarAnswer.data.videoHistory && servarAnswer.data.videoHistory[0].url === requestFilmInfo.trailLink) 
      cardConsider.querySelector('div[name=file-box-old-version]').style.display = 'none';
    else 
      cardConsider.querySelector('div[name=file-box-old-version]').style.display = 'flex';

    servarAnswer.data.videoHistory ?  videoHistoryMarkup.drawDataInContainer(servarAnswer.data.videoHistory, servarAnswer.data.notificationsVideo) :   videoHistoryMarkup.cleanContainer();

    displayBlockOnPermissions();
    // проверка на наличие булавки в с стеке открытых заявкок

    
    checkRequestInStackLastOpened();
    $(cardConsider).modal('show');
  };
};
  function checkRequestInStackLastOpened(){
    let bilo = false;
    let allTabs = stackLastOpenedCards.querySelectorAll('b');

    if(allTabs)
      allTabs.forEach((item) => {
        if (parseInt(item.attributes.fcid.nodeValue) === parseInt(currentRequestID))
          if (parseInt(item.attributes.pin.nodeValue) === 1)
            bilo = true;
      })

    if (bilo) {
     cardConsider.querySelector('button[name=setPinCard]').classList.remove('iconAddPin');
     cardConsider.querySelector('button[name=setPinCard]').classList.add('iconRemovePin');
    } else {
     cardConsider.querySelector('button[name=setPinCard]').classList.remove('iconRemovePin');
     cardConsider.querySelector('button[name=setPinCard]').classList.add('iconAddPin');
    }
    cardConsider.querySelector('button[name=setPinCard]').value = bilo ? 1 : 0;

  }

  function displayBlockOnPermissions() {
    
    //0 - блок спрятан
    //1 - ограниченное действие  - только просмотр
    //2 - полное взаимодействие

    //cardTabLocalNotes   - внутренние заметки и группы

    let arrPremissions = JSON.parse(auth.permissionsOnFest);

    if (parseInt(arrPremissions['cardTabWork'], 10) == 1) {
      cardConsider.querySelector('i[name=correctNameRUS]').classList.add('d-none');
      cardConsider.querySelector('i[name=correctNameEng]').classList.add('d-none');
      cardConsider.querySelector('i[name=fest-nomination-edit]').classList.add('d-none');

    } else {
      cardConsider.querySelector('i[name=correctNameRUS]').classList.remove('d-none');
      cardConsider.querySelector('i[name=correctNameEng]').classList.remove('d-none');
      cardConsider.querySelector('i[name=fest-nomination-edit]').classList.remove('d-none');
    }


// Информация по внутренним заметкам
    if (parseInt(arrPremissions['cardTabLocalNotes'], 10) == 0) 
      cardConsider.querySelector('button[name=localComments]').classList.add('d-none');
    else  if (parseInt(arrPremissions['cardTabLocalNotes'], 10) == 1) {
      cardConsider.querySelector('button[name=localComments]').classList.remove('d-none');
      cardConsider.querySelector('div[name=localCommentsAnswerBlock]').classList.add('d-none');
    } else {
      cardConsider.querySelector('div[name=localCommentsAnswerBlock]').classList.remove('d-none');
      cardConsider.querySelector('button[name=localComments]').classList.remove('d-none');
    }

    // Вкладки чаты и заметки
    if (parseInt(arrPremissions['cardTabChats'], 10) == 0) {
      cardConsider.querySelector('button[name=chatWithRej]').classList.add('d-none');
      cardConsider.querySelector('button[name=listRemarksWithRej]').classList.add('d-none');

    } else{
      cardConsider.querySelector('button[name=chatWithRej]').classList.remove('d-none');
      cardConsider.querySelector('button[name=listRemarksWithRej]').classList.remove('d-none');
    }

// Информация по заявке
    if (parseInt(arrPremissions['cardTabReqInfo'], 10) == 0) 
      cardConsider.querySelector('button[name=reguestInfo]').classList.add('d-none');
    else if (parseInt(arrPremissions['cardTabReqInfo'], 10) == 1) {
      cardConsider.querySelector('button[name=reguestInfo]').classList.remove('d-none');
      cardConsider.querySelector('button[name=disagreeRequest]').classList.add('d-none');
      cardConsider.querySelector('button[name=agreeRequest]').classList.add('d-none');
   
    } else if (parseInt(arrPremissions['cardTabReqInfo'], 10) == 2) {
      cardConsider.querySelector('button[name=reguestInfo]').classList.remove('d-none');
      cardConsider.querySelector('button[name=disagreeRequest]').classList.remove('d-none');
      cardConsider.querySelector('button[name=agreeRequest]').classList.remove('d-none');    
    }
    

    

  }

  function localTabsNotificationsUpdate (){

    cardConsiderallTabs.forEach((element) => {

        element.classList.remove('little-icon-newMsg');
        element.classList.remove('little-icon-newCmt');
    });
    if(currentNotification){
      currentNotification.forEach((element) => {
        if(element.remarkID)
          cardConsiderallTabsArea.querySelector('button[name="listRemarksWithRej"]').classList.add('little-icon-newMsg');
        else if(element.localCommentID)
          cardConsiderallTabsArea.querySelector('button[name="localComments"]').classList.add('little-icon-newCmt');

        
      });
    }

  }
  function initLocalTabs(type){
    
    cardConsiderallTabs.forEach((element) => {

        element.classList.remove('little-icon-newMsg');
        element.classList.remove('little-icon-newCmt');

       let keyName = element.attributes.name.nodeValue;
       if(keyName == 'cardFilm'){
        element.classList.add('active');
        cardConsider.querySelector(`div[name=tab_${keyName}]`).hidden = false;
       } else {
        element.classList.remove('active');
        cardConsider.querySelector(`div[name=tab_${keyName}]`).hidden = true;
       }

       if (typeRootViewController == 1) {

        cardConsider.querySelector('i[name="fest-nomination-edit"]').style.display = 'flex';

        cardConsider.querySelector('div[name="reviewsDecisions"]').style.display = 'flex';
        // cardConsider.querySelector('div[name="reviewsDecisions"]').style.text-align = 'center';
        cardConsider.querySelector('h5[name="reviewsDecisions"]').style.display = 'flex';
        cardConsider.querySelector('.modal-title').innerHTML = `Заявка на участие в кинофестивале <b class="m-0 p-0">№ ${currentNumberApplication}</b>`;
        cardConsider.querySelector('.modal-title2').innerHTML = `Заявка на участие в кинофестивале <b class="m-0 p-0">№ ${currentNumberApplication}</b>`;
       
        cardConsider.querySelector('div[name=blockLocalComments]').hidden = false;
        cardConsider.querySelector('div[name=blockNominationResults]').style.display = 'none';
        cardConsider.querySelector('div[name=blockRequestBTActions]').hidden = false;
        // cardConsider.querySelector('div[name=blockRequestCommentActions]').hidden = false;
       } else if (typeRootViewController == 0) {
        cardConsider.querySelector('i[name="fest-nomination-edit"]').style.display = 'none';
        cardConsider.querySelector('div[name="reviewsDecisions"]').style.display = 'none';
        cardConsider.querySelector('h5[name="reviewsDecisions"]').style.display = 'none';
        cardConsider.querySelector('.modal-title').innerHTML = `Заявка фильма:  <b class="m-0 p-0">№ ${currentNumberApplication}</b>`;
        cardConsider.querySelector('.modal-title2').innerHTML = `Заявка фильма:  <b class="m-0 p-0">№ ${currentNumberApplication}</b>`;
        cardConsider.querySelector('div[name=blockLocalComments]').hidden = true;
        cardConsider.querySelector('div[name=blockNominationResults]').style.display = 'flex';
        cardConsider.querySelector('div[name=blockRequestBTActions]').hidden = true;
        // cardConsider.querySelector('div[name=blockRequestCommentActions]').hidden = true;

       } else {
        // typeRootViewController == 2 ; локальный импорт заявки

        cardConsider.querySelector('i[name="fest-nomination-edit"]').style.display = 'flex';
        cardConsider.querySelector('div[name="reviewsDecisions"]').style.display = 'flex';
        // cardConsider.querySelector('div[name="reviewsDecisions"]').style.text-align = 'center';
        cardConsider.querySelector('h5[name="reviewsDecisions"]').style.display = 'flex';
        cardConsider.querySelector('.modal-title').innerHTML = `Импорт заявки <b class="m-0 p-0">№ ${currentNumberApplication}</b>`;
        cardConsider.querySelector('.modal-title2').innerHTML = `Импорт заявки <b class="m-0 p-0">№ ${currentNumberApplication}</b>`;
        cardConsider.querySelector('div[name=blockLocalComments]').hidden = false;
        cardConsider.querySelector('div[name=blockNominationResults]').style.display = 'none';
        cardConsider.querySelector('div[name=blockRequestBTActions]').hidden = false;
       }
    });
  };

  cardConsiderallTabsArea.addEventListener('click', function (evt) {
    evt.preventDefault();

    if (evt.target.attributes.name) {
      let choosedTab = evt.target.attributes.name.nodeValue;
      cardConsiderallTabs.forEach((element) => {
       
         let keyName = element.attributes.name.nodeValue;
         if (keyName == choosedTab) {
            if(keyName === 'listRemarksWithRej')
                loadAllRemarksWithDetails();
              else if (keyName === 'localComments')
                loadAllRemarkNotes();
              else if (keyName === 'reguestInfo')
                loadAllRemarkReviews();
              else if (keyName === 'chatWithRej')
                loadChatWithDetails();
              

          element.classList.add('active');
          cardConsider.querySelector(`div[name=tab_${keyName}]`).hidden = false;
         } else {
          element.classList.remove('active');
          cardConsider.querySelector(`div[name=tab_${keyName}]`).hidden = true;
         };
       });
    };

  });

  function displayCrew() {
    let arrPremissions = JSON.parse(auth.permissionsOnFest);
    let allCreatorsHTML = '';
    if(currentCrew)
      JSON.parse(currentCrew).forEach((element) => {
        allCreatorsHTML += `${searchPost(element.id)}: `;

        if(element.name.split(' ').length == 3){
          let arrSplitName = element.name.split(' ');
             allCreatorsHTML += `<b name="crew" class="mt-1">${arrSplitName[0]}</b>`;
                allCreatorsHTML += `<b name="crew" class="mt-1">${arrSplitName[1]}</b>`;
                   allCreatorsHTML += `<span name="crew" class="mt-1 colorGray">${arrSplitName[2]}</span>`;
        } else 
          allCreatorsHTML += `<b name="crew" class="mt-1">${element.name}</b>`;
        if (parseInt(arrPremissions['cardTabWork'], 10) == 2)
          allCreatorsHTML += `<button class="btn replaceFIO mr-1" valueToReplace ="${element.name}" type="button"> </button>`;
          allCreatorsHTML += `<button class="btn replaceFIORandom ml-0" valueToReplaceRandom ="${element.name}" type="button"> </button>`;

        allCreatorsHTML += '<br>';
      });
    cardConsider.querySelector('div[name=crew]').innerHTML = allCreatorsHTML;
  }


  function loadAllRemarkReviews(){
    reviewDecisionsMarkup.cleanContainer();
    xhr.request = {
        metod: 'GET',
        url: `filmRequest/${currentRequestID}/reviews`,
        data: '',
        callbackSuccess: onSuccessLoadAllReviews
      };
  }

const onSuccessLoadAllReviews = (servarAnswer) => {
  if (servarAnswer.status === 200) 
    reviewDecisionsMarkup.drawDataInContainer(servarAnswer.data);
  
};
const onSuccessLoadAllReviewsAndMainTable = (servarAnswer) => {
  if (servarAnswer.status === 200) {
    reviewDecisionsMarkup.drawDataInContainer(servarAnswer.data);
    loadData();
  }
  
};
  function loadAllRemarkNotes(){
    lastOpenedMarkup.cleanContainer();
    commentMarkup.cleanContainer();
    xhr.request = {
        metod: 'GET',
        url: `filmRequest/${currentRequestID}/notes`,
        data: '',
        callbackSuccess: onSuccessLoadAllNotes
      };
  }

const onSuccessLoadAllNotes = (servarAnswer) => {
  if (servarAnswer.status === 200) {
    commentMarkup.drawDataInContainer(servarAnswer.data.notes);
    lastOpenedMarkup.drawDataInContainer(servarAnswer.data.lastActivity);
    

    setTimeout(function() { 
      if (cardConsider.classList.contains('show') && cardConsiderallTabsArea.querySelector('button[name="localComments"]').classList.contains('active')) {

        xhr.request = {
          metod: 'GET',
          url: `filmRequest/${currentRequestID}/notesReaded`,
          data: '',
          callbackSuccess: onSuccessUpdatedGroup
        };
         // alert('проверка что почитаны заметки пройдена успешно');
      }
    }, 3000);
  }
};


  function loadChatWithDetails(){
    remarksMarkup.cleanContainer();
    xhr.request = {
        metod: 'GET',
        url: `filmRequest/${currentRequestID}/chat`,
        data: '',
        callbackSuccess: onSuccessLoadChat
      };
  }


const onSuccessLoadChatOrRemark = (servarAnswer) => {

  if (servarAnswer.status === 200) 
    if(servarAnswer.data.length > 0){
      if(servarAnswer.data[0].block === 'chat')
        onSuccessLoadChat(servarAnswer);
      else
        onSuccessLoadAllRemarks(servarAnswer);
    }
};

const onSuccessLoadChat = (servarAnswer) => {
  if (servarAnswer.status === 200) {
      setTimeout(function() { 
        cardConsiderallTabsArea.querySelector('button[name="chatWithRej"]').classList.remove('little-icon-newMsg');
        if(servarAnswer.data)
          currentNotificationsRemoveRemarkID(servarAnswer.data[0].remarkID);
      }, 1300);
    chatMarkup.drawDataInContainer(servarAnswer.data, currentNotification , chatHtmlBody);
  }
};
  function loadAllRemarksWithDetails(){
    remarksMarkup.cleanContainer();
    xhr.request = {
        metod: 'GET',
        url: `filmRequest/${currentRequestID}/remarks`,
        data: '',
        callbackSuccess: onSuccessLoadAllRemarks
      };
  }

const onSuccessLoadAllRemarks = (servarAnswer) => {
  if (servarAnswer.status === 200) 
    remarksMarkup.drawDataInContainer(servarAnswer.data, currentNotification);
  
};



  function searchPost(postID) {
    let postName = '';
    allPosts.forEach((element) => {
      if (parseInt(postID, 10) === parseInt(element.id, 10))
        postName = element.name;
      
    });
    return postName;
  }
  function makeClouds(value, type, globalID){
    let cloudHTML = '';
    let imageDiv = '';
    let altTitle = '';
    // let urlServerPic = 'https://festcontent.ru/img/';
    // let urlServerPic = '../img/';
    if (type === 'year'){
      imageDiv = `<img src="../img/icon-Year.png">`;
      altTitle = ` alt ="Год производства" `;
    } else  if (type === 'premiere'){
      let namePremiere = 'Не премьерный показ';
      imageDiv = `<img src="../img/premiere-none.png">`
      if(value === 1) {
        namePremiere = 'Российская премьера';
        imageDiv = `<img src="../img/premiere-russia.png">`
      } else if (value === 2) {
        namePremiere = 'Мировая премьера';
        imageDiv = `<img src="../img/premiere-world2.png">`
      }
      value = namePremiere;

    } else  if (type === 'long'){
      imageDiv = `<img src="../img/icon-Long.png">`;
      altTitle = ` alt ="Продолжительность" `;
      value = tools.secToFormattedLabel(value);

    } else if (type === 'age'){
      imageDiv = `<img src="../img/baby.png">`;
      altTitle = ` alt ="Возрастное ограничение" `;
      value = `${value} +`;
    } else if (type === 'rentalCert'){
      imageDiv = `<img src="../img/rentCert.svg">`;
      altTitle = ` alt ="Номер прокатного удостоверения" `;
    } else  if (type === 'tech'){
      imageDiv = `<img src="../img/icons8-art-64.png">`;
      altTitle = ` alt ="Техника" `;
    } else if (type === 'country'){
      imageDiv = `<img src="../img/earth2.png">`;
      altTitle = '';
    } else
    altTitle = ` aria-label = "${type}"`;
    let globalIDV = '';
    if(globalID  && globalID > 0)
      globalIDV = `-${globalID}`;
  
    if(!value)
      return '';
    else
      return `<div  role="text" class ="cloud" ${altTitle} name="other-${type}${globalIDV}">${imageDiv}${value}</div>`;
  }
  function makeFrame(value, previewSize){
      return `<div class ="frame previewSize${previewSize} "  popimg="${value}.jpg">
                <a href="${window.appSettings.xhrSettings.urlContentYCloud}films/${value}.jpg"   localName = "${value}"  target="_blank"> 
                  <img src="${window.appSettings.xhrSettings.urlContentYCloud}films/preview_${previewSize}/${value}.jpg" name="frame-${value}" localName = "${value}" class="shimmer">
                </a>
              </div>`;
  }

function getWidth() {

  if (document.documentElement && document.documentElement.clientWidth) {
    return document.documentElement.clientWidth;
  }

  if (document.body) {
    return document.body.clientWidth;
  }
  return 1000;
}



let elementToRemark = null;

cardConsider.addEventListener(('click'), function(evt)  {

  let arrPremissions = JSON.parse(auth.permissionsOnFest);



  if ((evt.shiftKey || evt.metaKey) && evt.target.attributes.name.nodeValue && typeRootViewController == 1) {
    if (parseInt(arrPremissions['cardTabWork'], 10) == 1)
      return; 

    let selected = window.getSelection();

    let strSelected = '';
    if (selected.baseNode) {
      strSelected = selected.baseNode.nodeValue;
      let indexStart = parseInt(selected.extentOffset,10);
      let indexEnd = parseInt(selected.baseOffset, 10);
      if(indexStart > indexEnd){
        let k = indexStart;
        indexStart = indexEnd;
        indexEnd = k;
      }
      strSelected = strSelected.substr(indexStart, indexEnd - indexStart);
    }

      
    let questionToRequester = prompt(`Укажите какой вопрос у вас по этому блоку: \n\n\nУточнение: ${strSelected}`);
   
    if (questionToRequester) {
      // let dataUrl
      elementToRemark = evt.target;
      xhr.request = {
        metod: 'POST',
        url: `filmRequest/${currentRequestID}/remark`,
        data: `block=${evt.target.attributes.name.nodeValue}&detail=${strSelected}&comment=${questionToRequester}`,
        callbackSuccess: onSuccessAddRemark
      };
    }


  } else if(evt.target.attributes.srcSource){
    //
    // взять все img с карточки и замениить src
    // alert(evt.target.attributes.srcSource.nodeValue);

    let allImgs = cardConsider.querySelectorAll('img');
    // let allAHref = cardConside.target
    let allAHref = cardConsider.querySelector('div[name=frames]').querySelectorAll('a');

    allAHref.forEach((element) => { 
      if(element.attributes.localName){
        if(evt.target.attributes.srcSource.nodeValue == 'servOwn')
          element.href = 'https://festcontent.ru/films/yandexcloudCopy/' + element.attributes.localName.nodeValue + '.jpg';
        else
          element.href = window.appSettings.xhrSettings.urlContentYCloud + 'films/' + element.attributes.localName.nodeValue + '.jpg';
      }
    })

    //
    allImgs.forEach((element) => { 
      console.log(element)
      if(element.attributes.localName)
        if(evt.target.attributes.srcSource.nodeValue == 'servOwn')
          element.src = 'https://festcontent.ru/films/yandexcloudCopy/' + element.attributes.localName.nodeValue + '.jpg';
        else
          element.src = `${window.appSettings.xhrSettings.urlContentYCloud}films/preview_300/` + element.attributes.localName.nodeValue + '.jpg';

    });

    if(evt.target.attributes.srcSource.nodeValue == 'servOwn')
      evt.target.attributes.srcSource.nodeValue = 'servYandex';
    else
     evt.target.attributes.srcSource.nodeValue = 'servOwn';


  } else if(evt.target.attributes.changeNomination){
    if (parseInt(arrPremissions['cardTabWork'], 10) == 1)
      return; 

    if (confirm('Вы точно хотите изменить конкурсную категорию?')) {
      $(cardConsider).modal('hide');
      changeFilmNomination(); 
    };

  } else if (evt.target.attributes.noteID) {
    if (parseInt(arrPremissions['cardTabWork'], 10) == 1)
      return; 
    if(confirm('Вы точно хотите удалить данную заметку?')){
      commentMarkup.cleanContainer();
      xhr.request = {
          metod: 'DELETE',
          url: `filmRequest/${currentRequestID}/note/${evt.target.attributes.noteID.nodeValue}`,
          data: '',
          callbackSuccess: onSuccessLoadAllNotes
        };
    }
  } else if (evt.target.attributes.msgID) {

    if (evt.target.attributes.msgID.nodeValue.length < 5) 
      alert('Удаление данного сообщения невозможно!');
    else 
    {
      if(confirm('Вы точно хотите удалить данное сообщение?')){
        commentMarkup.cleanContainer();
        xhr.request = {
            metod: 'DELETE',
            url: `filmRequest/${currentRequestID}/msg/${evt.target.attributes.msgID.nodeValue}`,
            data: '',
            callbackSuccess: onSuccessLoadChatOrRemark
          };
      }
    }
      
    
  } else if (evt.target.attributes.reviewValue) {
    if(!evt.target.classList.contains('current_review_answer'))
      if(confirm('Вы уверены в своем решении?')){
        commentMarkup.cleanContainer();
        xhr.request = {
            metod: 'PUT',
            url: `filmRequest/${currentRequestID}/review`,
            data: `answer=${evt.target.attributes.reviewValue.nodeValue}`,
            callbackSuccess: onSuccessLoadAllReviewsAndMainTable
          };
      }
  } else if(evt.target.attributes.valueToReplaceRandom){
    evt.target.classList.add('clicked');

    // alert(evt.target.attributes.valueToReplace.nodeValue);
    let stringToRepalce = '';
    let strinOLD =  evt.target.attributes.valueToReplaceRandom.nodeValue;
    let arraySplit =  evt.target.attributes.valueToReplaceRandom.nodeValue.split(" ");

    if (arraySplit && arraySplit.length > 2) {
      let shiftValue1 = arraySplit[1];
      let shiftValue2 = arraySplit[2];
      arraySplit[1] = shiftValue2;
      arraySplit[2] = shiftValue1;
    
      arraySplit.forEach((element) => { 
        stringToRepalce = `${stringToRepalce} ${element}`;
      })
    
      stringToRepalce = stringToRepalce.trim();
      // alert(stringToRepalce);
      xhr.request = {
        metod: 'PUT',
        url: `films/${currentFilmID}/crew`,
        data: `old=${strinOLD}&new=${stringToRepalce}`,
        callbackSuccess: onSuccessLoadCrew
      };

    } else
      evt.target.classList.remove('clicked');  
  } else if (evt.target.attributes.valueToReplace){
    evt.target.classList.add('clicked');
    // alert(evt.target.attributes.valueToReplace.nodeValue);
    let stringToRepalce = '';
    let strinOLD =  evt.target.attributes.valueToReplace.nodeValue;
    let arraySplit =  evt.target.attributes.valueToReplace.nodeValue.split(" ");

    if (arraySplit && arraySplit.length > 1) {
      let shiftValue = arraySplit.shift();
      arraySplit.push(shiftValue);
    
      arraySplit.forEach((element) => { 
        stringToRepalce = `${stringToRepalce} ${element}`;
      })
    
      stringToRepalce = stringToRepalce.trim();
      // alert(stringToRepalce);
      xhr.request = {
        metod: 'PUT',
        url: `films/${currentFilmID}/crew`,
        data: `old=${strinOLD}&new=${stringToRepalce}`,
        callbackSuccess: onSuccessLoadCrew
      };
    } else
      evt.target.classList.remove('clicked');  
  } else if (evt.target.attributes.btFilmID) 
    loadFilmCard(evt.target.attributes.btFilmID.nodeValue)

  // alert('f');
  
});

function  changeFilmNomination(){
  cardConsiderToChangeNomination.querySelector('h5[name=nameFilm]').innerHTML = cardConsider.querySelector('b[name=film-name]').innerHTML;
  if(!allNominaitons){
    xhr.request = {
      metod: 'GET',
      url: `festival/${auth.currentFestival}/nominations`,
      data: '',
      callbackSuccess: onSuccessLoadAllNominationsWithCard
    };
    // 
  } else {
    removeOptions(cardConsiderToChangeNominationSelect);
    allNominaitons.forEach((nomElem) => {
        let opt = document.createElement('option');
        opt.value = nomElem.id;
        opt.innerHTML = nomElem.name;
        if(nomElem.name === cardConsider.querySelector('b[name=fest-nomination]').innerHTML)
          opt.selected = true;
        
      cardConsiderToChangeNominationSelect.appendChild(opt);
    });
    $(cardConsiderToChangeNomination).modal('show');
  }
};


 cardConsiderToChangeNomination.querySelector('button[name=cancel]').addEventListener('click', function () {
  
    $(cardConsiderToChangeNomination).modal('hide');

    setTimeout(function() { 
      $(cardConsider).modal('show');
    }, 1000);
 });


 cardConsiderToChangeNomination.querySelector('button[name=send]').addEventListener('click', function () {
 
   xhr.request = {
      metod: 'PUT',
      url: `filmRequest/${currentRequestID}/nomination/${cardConsiderToChangeNominationSelect.value}`,
      data: '',
      callbackSuccess: onSuccessLoadPutNomination
    };
 });

const onSuccessLoadPutNomination = (servAnswer) => {

  $(cardConsiderToChangeNomination).modal('hide');
  if (servAnswer.status === 200) 
    setTimeout(function() { 
      loadRequestFilm(currentRequestID, false);
    }, 1000);

  

};
 


function removeOptions(selectbox) {
  for (let i = selectbox.options.length - 1; i >= 0; i--) {
    selectbox.remove(i);
  }
}

const onSuccessLoadAllNominations = (servAnswer) => {
  if (servAnswer.status === 200) {
    // alert('dfdf');
    allNominaitons = servAnswer.data;
    removeOptions(cardConsiderToChangeNominationSelect);
    removeOptions(cardLocalInputNominationSelect);
    allNominaitons.forEach((nomElem) => {
        let opt = document.createElement('option');
        opt.value = nomElem.id;
        opt.innerHTML = nomElem.name;
        if(nomElem.name === cardConsider.querySelector('b[name=fest-nomination]').innerHTML)
          opt.selected = true;

      cardConsiderToChangeNominationSelect.appendChild(opt);
      cardLocalInputNominationSelect.appendChild(opt);
    });

  }
};


const onSuccessLoadAllNominationsWithCard = (servAnswer) => {
    onSuccessLoadAllNominations(servAnswer);
    if (servAnswer.status === 200)
      $(cardConsiderToChangeNomination).modal('show');
};
      // allNominaiton     $(cardConsiderToChangeNomination).modal('show');

function loadFilmCard (filmID) {
  if(parseInt(filmID, 10) >0)
    xhr.request = {
      metod: 'GET',
      url: `festival/${auth.currentFestival}/film/${filmID}/reqID`,
      data: '',
      callbackSuccess: onSuccessLoadReqID
    };
  else
    localInputBlock.openCard(filmID);
}

const onSuccessLoadReqID = (servAnswer) => {
  if (servAnswer.status === 200) {
    if (servAnswer.data) {
      $(cardConsider).modal('hide');
      setTimeout(function() { 
        loadRequestFilm(servAnswer.data, false);

      },300);
      setTimeout(function() { 
        cardConsider.querySelector('.modal-title').innerHTML = `Заявка на участие в кинофестивале <b class="m-0 p-0">№ ${servAnswer.message}</b>`;
      },800);

    } else 
      alert('Доступ к данному фильму закрыт. Обратитесь к администратору.');
  }
};

function loadFilmRequest (regID) {

}

const onSuccessLoadCrew = (servarAnswer) => {
  if (servarAnswer.status === 200) {
    currentCrew = servarAnswer.data;
    displayCrew();

  }
};

const onSuccessAddRemark = (servarAnswer) => {
  if (servarAnswer.status === 200) {
    alert('Замечание добавлено!');
    elementToRemark.classList.add('blockHaveQuestion');
  }
};

const onSuccessAddRemarkMsg = (servarAnswer) => {
  if (servarAnswer.status === 200) {
    loadAllRemarksWithDetails();
  }
};

const onSuccessAddChat = (servarAnswer) => {
  if (servarAnswer.status === 200) {
    loadChatWithDetails();
  }
};


function currentNotificationsRemoveRemarkID(rID){
  let arrN = []; 
  let notRmk = true;
  if(currentNotification){
    currentNotification.forEach((element) => {
      if(element.remarkID && element.remarkID != rID)
        notRmk = false;
      

      if(element.remarkID != rID)
        arrN.push(element);
    });
    currentNotification = arrN;
    localTabsNotificationsUpdate();
  }
  
  if (notRmk && allNotifications){
    let allN = [];
    allNotifications.forEach((nElement) => {
      if(nElement.considerIDNewMessage != currentRequestID)
        allN.push(nElement);
    });
    allNotifications = allN;

  if (allNotificationsVideo.length === 0)
    mainTabPaneBTLookNewLinks.classList.remove('activeBtn');

  if (allNotifications.length === 0)
    mainTabPaneBTLookMsgChat.classList.remove('activeBtn');
  else
    reDisplayData();
  }

};

function loadRequestFilm(reqID, source){

  let arrPremissions = JSON.parse(auth.permissionsOnFest);
  if (parseInt(arrPremissions['cardTabWork'], 10) == 0) 
    alert('Доступ ограничен администратором.');
  else {
    currentRequestID = reqID;
    xhr.request = {
      metod: 'GET',
      // url: `festival/${auth.currentFestival}/filmAFConsider/${currentRequestID}`,
      url: `filmRequest/${currentRequestID}/source/${source}`,
      data: '',
      callbackSuccess: onSuccessConsiderLoad
    };
  }
};


cardConsider.querySelector('div[name=chatBody]').addEventListener('click', function (evt) {
 
    if(evt.target && evt.target.attributes && evt.target.attributes.type && evt.target.attributes.type.nodeValue === 'button') {
      let nameOperation = evt.target.attributes.name.nodeValue;  
      let remarkID = 0;
      if(evt.target.attributes.remarkID)
        remarkID = evt.target.attributes.remarkID.nodeValue;
    

      if (nameOperation === 'createNewChat') {
          xhr.request = {
            metod: 'POST',
            url: `filmRequest/${currentRequestID}/remark`,
            data: `block=chat&detail=-&comment=-`,
            callbackSuccess: onSuccessAddChat
          };
      } else if(nameOperation === 'sendMsg'){
         let inputField = cardConsider.querySelector(`input[name=remark-${remarkID}-input]`);
        currentNotificationsRemoveRemarkID(remarkID);
        xhr.request = {
          metod: 'POST',
          url: `filmRequest/${currentRequestID}/msg`,
          data: `text=${inputField.value}&remark=${remarkID}`,
          callbackSuccess: loadChatWithDetails
        };
        inputField.value = '';
      }
    }
  });

cardConsider.querySelector('div[name=remarksBody]').addEventListener('click', function (evt) {
 
    if(evt.target && evt.target.attributes && evt.target.attributes.type && evt.target.attributes.type.nodeValue === 'button')
    {
      let nameOperation = evt.target.attributes.name.nodeValue;

      let remarkID = 0;
      if(evt.target.attributes.remarkID)
        remarkID = evt.target.attributes.remarkID.nodeValue;
    
      if (nameOperation === 'sendRemark'){

        let inputField = cardConsider.querySelector(`input[name=remark-${remarkID}-input]`);
        currentNotificationsRemoveRemarkID(remarkID);
        xhr.request = {
          metod: 'POST',
          url: `filmRequest/${currentRequestID}/msg`,
          data: `text=${inputField.value}&remark=${remarkID}`,
          callbackSuccess: loadAllRemarksWithDetails
        };
        inputField.value = '';
      } else if (nameOperation === 'cancelRemark') {
        if(confirm('Вы действительно хотите отменить данное замечание?')){
          currentNotificationsRemoveRemarkID(remarkID);
          xhr.request = {
            metod: 'DELETE',
            url: `filmRequest/${currentRequestID}/remark/${remarkID}`,
            data: '',
            callbackSuccess: loadAllRemarksWithDetails
          };
        }

      } else if (nameOperation === 'createNewRemark') {
        // xhr.request = {
        //   metod: 'POST',
        //   url: `filmRequest/${currentRequestID}/remark`,
        //   data: `block=remark&detail=-&comment=-`,
        //   callbackSuccess: onSuccessAddRemarkMsg
        // };
        alert('Данная функция заблокирована до 1 марта 2022 г. Для создания нового замечания, используйте системную клавишу (Ctrl или Command) и клик мыши по одному из блоков на заявке.');

      } else if (nameOperation === 'rejectRemark') {
        if(confirm('Вы действительно хотите отклонить данное замечание?')){
          currentNotificationsRemoveRemarkID(remarkID);
          xhr.request = {
            metod: 'PUT',
            url: `filmRequest/${currentRequestID}/remark/${remarkID}`,
            data: 'status=1',
            callbackSuccess: onSuccessAddRemarkMsg
          };
        }

      } else if (nameOperation === 'agreeRemark') {

        if(confirm('Вы действительно хотите подтвердить, что данное замечание исправлено верно?')){
          currentNotificationsRemoveRemarkID(remarkID);
          xhr.request = {
            metod: 'PUT',
            url: `filmRequest/${currentRequestID}/remark/${remarkID}`,
            data: 'status=3',
            callbackSuccess: onSuccessAddRemarkMsg
          };
        }
      }
    }
  });
  // ONLY MEDIATEKA CINEMAFEST


let allMediateka = [];

const menuBtFilms =  document.querySelector('#MenuAllFilms');

  function initFirstSetupRequstFilms () {

    typeRootViewController = 1;

    currentGroup = 0;
    arrayGroups.querySelectorAll('.considerGroup').forEach((element) => {
      if (currentGroup == element.attributes.value.nodeValue)
        element.classList.add('active'); 
      else
        element.classList.remove('active');
     });

    mainTabPane.querySelector('h2[name="nameView"]').innerHTML = 'Входящие заявки';
    mainTabPane.querySelector('div[name="foldersRow"]').style.display = 'flex';
    mainTabPaneBTAdd.style.display = 'none';
    mainTabPaneBTAddGlobalChat.style.display = 'flex';
    mainTabPaneBTLookMsgChat.style.display = 'flex';
    mainTabPaneBTLookMsgChat.style.display = 'flex';
    mainTabPaneBTDataSort.style.display = 'flex';
    initFirstSetup();
  };


// DEFINE LOCAL INPUT 
  mainTabPaneBTAdd.addEventListener('click', function () {
    xhr.request = {
      metod: 'POST',
      url: `localInputFilms/`,
      data: '',
      callbackSuccess: loadData
    };
  });

  function initFirstSetupMediateka () {
    typeRootViewController = 0;
    currentGroup = 0;
    mainTabPane.querySelector('h2[name="nameView"]').innerHTML = 'Фильмы фестиваля';
    mainTabPane.querySelector('div[name="foldersRow"]').style.display = 'none';
    mainTabPaneBTAdd.style.display = 'none';
    mainTabPaneBTLookMsgChat.style.display = 'flex';
    mainTabPaneBTLookMsgChat.style.display = 'flex';
    mainTabPaneBTAddGlobalChat.style.display = 'flex';
    mainTabPaneBTDataSort.style.display = 'flex';

    initFirstSetup();

  }

  function initFirstSetupLocalInputFilms () {
    typeRootViewController = 2;
    currentGroup = 0;
    mainTabPane.querySelector('h2[name="nameView"]').innerHTML = 'Ручной импорт заявок';
    mainTabPane.querySelector('div[name="foldersRow"]').style.display = 'none';
    mainTabPaneBTAdd.style.display = 'flex';
    mainTabPaneBTLookMsgChat.style.display = 'none';
    mainTabPaneBTAddGlobalChat.style.display = 'none';
    mainTabPaneBTLookMsgChat.style.display = 'none';
    mainTabPaneBTDataSort.style.display = 'none';

    if(!allNominaitons) {
      // alert('try');
      xhr.request  = {
        metod: 'GET',
        url: `festival/${auth.currentFestival}/nominations`,
        data: '',
        callbackSuccess: onSuccessLoadAllNominations
      }; 
    } 

    initFirstSetup();

  }


// обработчик поиска

const  cancelSmartSearch = () => {

    
  mainTabPane.querySelector('div[name="foldersRow"]').hidden = false;
  mainTabPaneBody.style.display = 'flex';
  alert('101111111111');
}


// обработчик для стека - последний открытых карточек.!

const stackLastOpenedCards =  mainTabPane.querySelector('div[name=lastOpened]');

stackLastOpenedCards.querySelector('button[name=btTypeView]').addEventListener('click', function () {
   
   if (stackLastOpenedCards.classList.contains('lineMode'))
    stackLastOpenedCards.classList.remove('lineMode');
  else
    stackLastOpenedCards.classList.add('lineMode');
});



stackLastOpenedCards.querySelector('div[name=lastOpenBody]').addEventListener('click', function (evt) {

  if(evt.target.attributes.fCID && typeRootViewController < 2){
    if(evt.target.attributes.numReq)
      currentNumberApplication = evt.target.attributes.numReq.nodeValue;
    else 
      currentNumberApplication = 0;

    loadRequestFilm(evt.target.attributes.fCID.nodeValue, 'stackLastOpened');
  } else if(evt.target.attributes.fCID && typeRootViewController == 2)
     localInputBlock.openCard(evt.target.attributes.fCID.nodeValue);
  
});


const menuBtLocalInputFilms =  document.querySelector('#MenuSimpleCardFilms');



export default {

  start() {
    menuBtFilms.addEventListener('click', initFirstSetupMediateka);
    menuBt.addEventListener('click', initFirstSetupRequstFilms);
    menuBtLocalInputFilms.addEventListener('click', initFirstSetupLocalInputFilms);   
  },
   getPosts(){
    return allPosts;
   },
  loadRequestFilmApplication(fID){
    initFirstSetupMediateka();
    loadFilmCard(fID);
  },
  loadRequestFilmApplicationById(fID, numReq){
    initFirstSetupMediateka();
    loadRequestFilm(fID, false);
    currentNumberApplication = numReq;
  },

  stop() {
    mainMarkup.cleanContainer();
    menuBtFilms.removeEventListener('click', initFirstSetupMediateka);
    menuBt.removeEventListener('click', initFirstSetupRequstFilms);
    menuBtLocalInputFilms.removeEventListener('click', initFirstSetupLocalInputFilms); 
  
  }
};
